import { ExportToCsv } from 'export-to-csv';
import _ from 'lodash';
import React from 'react';
import HomeIcon from '@material-ui/icons/Home';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import moment from 'moment';
import { ORDER_SUCCESS, ALLSHOP } from '../../constants';
import { displayPhoneNumberFormat, isStringNotNull } from '../../utils/tools';

const optionsCsv = {
  filename: 'Liste clients',
  decimalSeparator: ',',
  showLabels: true,
  useKeysAsHeaders: true
};
export const initUsers = async (props, component) => {
  const { shopId, isAllShops } = props;
  const { allUsers } = component.state;
  const clients = {};
  const allClients = {};
  if (allUsers) {
    _.map(allUsers, (userId, index) => {
      const {
        firstName = '',
        lastName = '',
        email,
        numero: number = '',
        promotions,
        points = '',
        birthdate = '',
        cards = {},
        newsletter = false,
        shopIds = [],
        billing
      } = userId;
      if (isStringNotNull(email)) {
        const { exp_month: expMonth = '', exp_year: expYear = '', numb: cardNumber = '' } = _.keys(
          cards
        ).length
          ? cards[_.keys(cards)[0]]
          : cards;
        const shop = _.find(shopIds, id => {
          return id === shopId || id.shopId === shopId;
        });
        const shopWithFirstOrder = _.orderBy(
          shopIds,
          ({ firstOrderTime }) => firstOrderTime || '',
          ['asc']
        )[0];
        const shopIdCheck = !!shop;
        let nbTransaction = 0;
        let nbTransactionCanceled = 0;
        let totalMoneySpent = 0;
        const sortedBillings = _.orderBy(billing, ['date'], ['desc']);
        _.map(billing, bill => {
          const { status, priceOrder } = bill;
          if (status === ORDER_SUCCESS) {
            nbTransaction++;
          } else {
            nbTransactionCanceled++;
          }
          totalMoneySpent += priceOrder;
        });
        totalMoneySpent = Math.round(totalMoneySpent * 100) / 100;
        const lastBilling = sortedBillings[_.keys(sortedBillings)[0]];
        const customer = {
          firstName,
          lastName,
          email,
          number: displayPhoneNumberFormat(number),
          promotions: promotions ? _.values(promotions) : [],
          expMonth,
          expYear,
          points,
          birthdate,
          cardNumber,
          newsletter,
          id: index,
          lastBilling: lastBilling || {},
          nbTransaction,
          nbTransactionCanceled,
          totalMoneySpent,
          billing
        };

        allClients[index] = {
          ...customer,
          dateObj:
            shopWithFirstOrder && shopWithFirstOrder.firstOrderTime
              ? moment(shopWithFirstOrder.firstOrderTime)
              : null
        };
        if (shopIdCheck)
          clients[index] = {
            ...customer,
            dateObj: shop && shop.firstOrderTime ? moment(shop.firstOrderTime) : null
          };
      }
    });

    component.setState({
      clients: _.orderBy(clients, ({ dateObj }) => dateObj || '', ['desc']),
      allClients: _.orderBy(allClients, ({ dateObj }) => dateObj || '', ['desc']),
      currentClients: _.orderBy(isAllShops ? allClients : clients, ({ dateObj }) => dateObj || '', [
        'desc'
      ]),
      isLoading: false
    });
  }
};

export const handleSearchChange = async (e, component) => {
  await component.setState({ searchTerm: e.target.value });
  handleSearchBlur(component);
};

export const handleSearchBlur = component => {
  const { clients, allClients } = component.state;
  const { isAllShops } = component.props;
  const dataToUse = isAllShops ? allClients : clients;
  const filteredClients = dataToUse
    .slice(0, 5000)
    .filter(client =>
      client.email.toLowerCase().includes(component.state.searchTerm.toLowerCase())
    );
  component.setState({ currentClients: filteredClients });
};

export const handleChange = (panel, component) => (event, expanded) => {
  component.setState({
    expanded: expanded ? panel : false
  });
};

export const handleClick = (event, component) => {
  component.setState({ anchorEl: event.currentTarget });
};

export const handleClose = component => {
  component.setState({ anchorEl: null });
};

export const handleExporteToCsv = async component => {
  component.setState({ anchorEl: null });
  const { clients, allClients } = component.state;
  const { isAllShops, shops } = component.props;
  const currentClients = isAllShops ? allClients : clients;
  let csvExporter = null;
  const array = [];
  _.map(_.orderBy(currentClients, ['lastName'], ['asc']), client => {
    const {
      email,
      number,
      firstName,
      newsletter = false,
      lastName,
      lastBilling,
      nbTransaction,
      nbTransactionCanceled,
      totalMoneySpent
    } = client;
    const { shopId } = lastBilling;
    const data = {
      Nom: lastName,
      Prénom: firstName,
      Email: email.length > 0 && email,
      Numéro: number.length > 0 && number,
      RGPD: newsletter,
      Commandes: nbTransaction,
      Annulations: nbTransactionCanceled,
      total: `${totalMoneySpent.toFixed(2)} €`
    };
    if (isAllShops) data['Dernier magasin'] = shopId ? (shops[shopId]?.name || shopId) : '--';
    array.push(data);
  });

  csvExporter = await new ExportToCsv(optionsCsv);
  csvExporter.generateCsv(array);
};
export const getBottomNavigationData = data => {
  const newData = [];
  _.map(data, e => {
    newData.push({
      label: e,
      icon: e === ALLSHOP ? <AccountBalanceIcon /> : <HomeIcon />
    });
  });
  return newData;
};
export const onChangeData = (e, value, component) => {
  const { initPage } = component.props;
  const { clients, allClients } = component.state;

  e.preventDefault();
  initPage();
  component.setState({
    bddSelected: value,
    currentClients: value === 1 ? allClients.slice(0, 5000) : clients.slice(0, 5000)
  });
};

export const getBottomNavigationComponentSize = numberOfItems => {
  let classNameBottomNavigation = 'col-sm-4 col-md-3 col-lg-2';
  if (numberOfItems > 1) {
    classNameBottomNavigation = 'col-sm-6 col-md-5 col-lg-4 col-xl-3';
  }
  return classNameBottomNavigation;
};

export const handleRowClick = (client, component) => {
  component.setState({ modalOpen: true, client });
};
export const handleCloseModal = component => {
  component.setState({ modalOpen: false });
};
